var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPtsPuzzle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.2878 0.855978C10.3538 0.855978 8.76239 2.37374 8.76239 4.24728C8.76239 5.08754 9.08952 5.73666 9.60909 6.45769C10.0324 7.04624 10.0094 7.36418 9.96317 7.45691C9.91698 7.54964 9.7438 7.66887 9.2858 7.63859C8.08887 7.5591 4.25175 7.12384 4.25175 7.12384V7.13898C3.78799 7.07652 3.32423 7.27145 3.08176 7.59317C2.84699 7.90542 2.75847 8.27256 2.71229 8.65295V8.68323C2.71036 8.69459 2.69882 8.70216 2.69689 8.71351H2.71229C2.70652 8.73433 2.49869 9.67678 2.18887 13.6793C2.18502 13.7418 2.17925 13.6926 2.17348 13.755H2.18887C2.16385 13.9424 2.18502 14.1108 2.18887 14.1335C2.25045 14.442 2.42364 14.7486 2.71229 14.8905C3.00094 15.0325 3.29344 14.9946 3.5436 14.9208C4.04585 14.7732 4.51924 14.4439 5.00609 14.1033C5.58147 13.7021 6.1222 13.4523 6.74569 13.4523C8.16007 13.4523 9.2858 14.5366 9.2858 15.8746C9.2858 17.2126 8.16007 18.297 6.74569 18.297C6.04331 18.297 5.64497 18.1191 4.9753 17.6005C4.60198 17.3129 4.16516 17.0006 3.69755 16.8284C3.46278 16.7433 3.21262 16.6922 2.92781 16.7527C2.64301 16.8133 2.36783 17.0442 2.25045 17.328C2.12922 17.6195 2.13499 17.8239 2.17348 18.0699C2.1754 18.0945 2.17155 18.0756 2.17348 18.1002C2.46405 21.0657 2.6103 21.3552 2.71229 21.7943C2.78541 22.1084 2.91627 22.4282 3.15873 22.6875C3.4012 22.9468 3.78414 23.1417 4.20557 23.1417H19.9851C20.5335 23.1417 21.03 22.9638 21.3706 22.6269C21.7112 22.2901 21.8632 21.8226 21.8632 21.3249V8.78921C21.8632 8.32366 21.6881 7.92624 21.4168 7.65373C21.1455 7.38121 20.8106 7.23171 20.4931 7.13898C20.4335 7.12194 20.37 7.11816 20.3084 7.12384C20.3084 7.12384 16.6002 7.4853 15.2589 7.63859C14.8683 7.68211 14.7336 7.59695 14.6739 7.47205C14.6143 7.34715 14.5893 6.99326 14.951 6.42741C15.2243 5.99971 15.434 5.68745 15.5822 5.35248C15.7304 5.01752 15.7977 4.66552 15.7977 4.24728C15.7977 2.37374 14.2217 0.855978 12.2878 0.855978Z",
    fill: "url(#paint_fill_puzzle)",
    stroke: "url(#paint_fill_puzzle)",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_fill_puzzle",
    x1: 0.768948,
    y1: 26.3731,
    x2: 27.0604,
    y2: 2.52645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtsPuzzle);
export default __webpack_public_path__ + "static/media/pts_puzzle.2e8038fb1e361711c2eb2107b04406de.svg";
export { ForwardRef as ReactComponent };